<template>
  <article class="document-list-card" @click="$emit('select')">
    <div class="document-list-card__top">
      <div class="document-list-card__identity">
        <p class="document-list-card__number">{{ number }}</p>
        <h2 class="document-list-card__customer text-body-large-strong">{{ customerName }}</h2>
      </div>
      <document-status-pill :status="status" />
    </div>

    <p v-if="hasReference" class="document-list-card__reference">{{ referenceText }}</p>

    <div class="document-list-card__footer">
      <div class="document-list-card__dates">
        <p class="document-list-card__date">
          <span class="document-list-card__date-label">Issued:</span>
          <span class="document-list-card__date-value">{{ issuedDate }}</span>
        </p>
        <p class="document-list-card__date">
          <span class="document-list-card__date-label">{{ secondaryDateLabel }}:</span>
          <span class="document-list-card__date-value">{{ secondaryDate }}</span>
        </p>
      </div>
      <p class="document-list-card__amount">{{ amountText }}</p>
    </div>
  </article>
</template>

<script>
import DocumentStatusPill from './DocumentStatusPill.vue'

export default {
  name: 'DocumentListCard',
  components: {
    DocumentStatusPill
  },
  props: {
    number: { type: String, default: '-' },
    customerName: { type: String, default: '-' },
    reference: { type: String, default: '-' },
    issuedDate: { type: String, default: '-' },
    secondaryDate: { type: String, default: '-' },
    secondaryDateLabel: { type: String, default: 'Expiry' },
    amountText: { type: String, default: '$0.00' },
    status: { type: String, default: '' }
  },
  computed: {
    referenceText: function () {
      return String(this.reference || '').trim()
    },
    hasReference: function () {
      const text = this.referenceText
      return text !== '' && text !== '-'
    }
  }
}
</script>

<style scoped>
.document-list-card {
  border: 1px solid var(--color-border-document-card);
  border-radius: 12px;
  background: var(--color-bg-document-card);
  padding: 16px 18px;
  box-sizing: border-box;
}

.document-list-card__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.document-list-card__identity {
  min-width: 0;
  flex: 1 1 auto;
}

.document-list-card__number {
  margin: 0;
  font-family: var(--font-regular);
  font-size: 12px;
  font-weight: 400;
  line-height: 1.25;
  color: var(--color-text);
}

.document-list-card__customer {
  margin: 0;
  line-height: 1.25;
  color: var(--color-text);
}

.document-list-card__reference {
  margin: 4px 0 0;
  font-family: var(--font-regular);
  font-size: 12px;
  font-weight: 400;
  line-height: 1.4;
  color: var(--color-text);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.document-list-card__footer {
  margin-top: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.document-list-card__dates {
  min-width: 0;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.document-list-card__date {
  margin: 0;
  display: flex;
  align-items: baseline;
  gap: 4px;
  font-size: 12px;
  line-height: 1.25;
}

.document-list-card__date-label {
  font-family: var(--font-semibold);
  font-weight: 600;
  color: var(--color-text);
}

.document-list-card__date-value {
  font-family: var(--font-regular);
  font-weight: 400;
  color: var(--color-text);
}

.document-list-card__amount {
  margin: 0;
  flex-shrink: 0;
  font-family: var(--font-semibold);
  font-size: 14px;
  font-weight: 600;
  line-height: 1.25;
  color: var(--color-text);
  text-align: right;
}
</style>
